/* eslint-disable react/prop-types */
import { FC } from "react";
import { X } from "@phosphor-icons/react";
import {
	Dialog,
	DialogContent,
	DialogTitle,
	DialogClose
} from "src/components/ui/dialog";
import SocialPost, {
	SocialPostProps
} from "src/features/SocialFeedContent/components/SocialPost/SocialPost";

interface PostDetailDialogProps {
	post: SocialPostProps | null;
	isOpen: boolean;
	onClose: () => void;
}

const PostDetailDialog: FC<PostDetailDialogProps> = ({
	post,
	isOpen,
	onClose
}) => {
	if (!post) return null;

	return (
		<Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
			<DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto p-0 rounded-xl [&>button:last-child]:hidden">
				<DialogTitle className="sr-only">Post details</DialogTitle>
				<div className="flex justify-end px-3 pt-3">
					<DialogClose className="flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-md border border-border transition-colors hover:bg-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-ring">
						<X className="h-4 w-4 text-foreground" />
						<span className="sr-only">Close</span>
					</DialogClose>
				</div>
				<div>
					<SocialPost
						id={post.id}
						authorId={post.authorId}
						authorName={post.authorName}
						authorRole={post.authorRole}
						authorAvatarUrl={post.authorAvatarUrl}
						body={post.body}
						images={post.images}
						videos={post.videos}
						hashtags={post.hashtags}
						isSponsored={post.isSponsored}
						sponsorName={post.sponsorName}
						publishedDate={post.publishedDate}
						commentsCount={post.commentsCount}
						reactionsCount={post.reactionsCount}
						userReaction={post.userReaction}
						isSaved={post.isSaved}
						expandComments
						bare
					/>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default PostDetailDialog;
